module.exports = __webpack_public_path__ + "static/media/community_solidarity.ecfd4882.png";